import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetDocumentQueueRequestType,
  GetDocumentQueueResponseType,
} from '../types';

export const getDocumentsQueue = async (
  params: GetDocumentQueueRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/queue`;
  const response = await apiAuthClient.get<GetDocumentQueueResponseType>(url);

  return response.data;
};
